/* eslint-disable @next/next/no-img-element */
'use client';
import { FC, useState } from 'react';

import { Grid } from '@gds/Grid/Grid';
import { Typography } from '@gds/Typography/Typography';

import styles from './EmbeddedVideo.module.css';

type Props = {
  cmsData: any;
};
const EmbeddedVideo: FC<Props> = ({ cmsData }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const handleClick: React.MouseEventHandler<HTMLButtonElement> = e => {
    e.preventDefault();
    setIsPlaying(true);
  };
  const videoId = cmsData.elements.youtube_video_url.value.split('v=')[1];
  const title = cmsData.elements.video_headline.value;
  return (
    videoId && (
      <Grid.Row className="blogCmpnt" justify="center">
        <Grid.Col width={{ mobile: 12, tablet: 12, desktop: 8 }}>
          <Typography variant="h2">{title}</Typography>
          <div className={styles.video}>
            {isPlaying ? (
              <iframe
                src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
                title={title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            ) : (
              <button type="button" onClick={handleClick} className={styles.overlay}>
                <img
                  src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                  width="100%"
                  alt={title}
                />
                <span className={styles.button}>
                  <svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%">
                    <path
                      className="ytp-large-play-button-bg"
                      d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"
                      fill="#f00"
                    />
                    <path d="M 45,24 27,14 27,34" fill="#fff" />
                  </svg>
                </span>
              </button>
            )}
          </div>
        </Grid.Col>
      </Grid.Row>
    )
  );
};

export default EmbeddedVideo;
